import React, { useState } from "react";
import UserCardBinding from "./UserCardBinding";
import UserCardCharge from "./UserCardCharge";
import UserCardChargeHistory from "./UserCardChargeHistory";
import { usePermissions } from "../App/PermissionContext";
import { PERMISSIONS } from "../../constants/roles";

const UserCreditCard = ({ merchant }) => {
  const { permissions } = usePermissions();
  const [chargeCount, setChargeCount] = useState(0);

  return (
    <>
      <UserCardBinding merchant={merchant} />
      {permissions.includes(PERMISSIONS.CHARGE_CARD) && (
        <UserCardCharge merchant={merchant} onCharged={() => setChargeCount((count) => count + 1)} />
      )}
      <UserCardChargeHistory merchantId={merchant?.merchantId} refreshKey={chargeCount} />
    </>
  );
};

export default UserCreditCard;
